// External libraries
import React from 'react';
import styled from 'styled-components';

// Zocdoc libraries
import { navy } from '@zocdoc/branding/colors';

// Icon code
import { Icon } from './_base';

const InfoSVG = styled(Icon).attrs({ viewBox: '0 0 13 13' })``;

const Info = ({ color = navy, ...props }) => (
    <InfoSVG data-test="icon-info" {...props}>
        <path
            d="M6.5 0A6.5 6.5 0 1 0 13 6.5 6.507 6.507 0 0 0 6.5 0zm0 11.96a5.46 5.46 0 1 1 5.46-5.46 5.466 5.466 0 0 1-5.46 5.46z"
            fill={color}
        />
        <path
            d="M5.72 3.12h1.56v1.56H5.72zm0 2.6h1.56v4.42H5.72z"
            fill={color}
        />
    </InfoSVG>
);

export { Info as default, Info };
